<h1 mat-dialog-title>Pobierz dane z GUS</h1>
<mat-dialog-content class="mat-typography">
	<mat-form-field class="w-100">
		<input
			matInput
			type="text"
			inputmode="numeric"
			autocomplete="off"
			placeholder="Wprowadź numer NIP"
			#organizationData
			(keydown.enter)="uploadOrganizationData(organizationData.value)"
		/>
	</mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button mat-dialog-close color="warn">Anuluj</button>
	<button
		mat-raised-button
		cdkFocusInitial
		color="primary"
		[disabled]="isLoading()"
		(click)="uploadOrganizationData(organizationData.value)"
	>
		@if (isLoading()) {
			Pobieranie…
		} @else {
			Wgraj dane
		}
	</button>
</mat-dialog-actions>
